// styles.js
import styled from 'styled-components';

/* Progress bar */
export const ProgressBar = styled.div`
  width: 100%;
  height: 0.5rem;
  background: #e5e7eb; /* gray-200 */
`;
export const ProgressFill = styled.div`
  height: 100%;
  width: 100%;
  background: #a3e635; /* lime-400 */
`;

/* Page container */
export const Container = styled.div`
  max-width: 48rem; /* ~max-w-3xl */
  margin: 0 auto;
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem; /* sm:p-6 */
  }
`;

/* Header area */
export const CenterHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;

  @media (min-width: 640px) {
    margin-bottom: 3rem; /* sm:mb-12 */
  }
`;

export const SuccessIconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem auto; /* mx-auto mb-6 */
`;

export const Title = styled.h1`
  margin: 0 0 0.5rem 0;
  color: #231F20;
  font-weight: 600;
  font-size: 32px;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #4b5563; /* gray-600 */
  font-weight: 400;
  font-size: 1rem; /* text-base */
  @media (min-width: 640px) {
    font-size: 1.125rem;
  } /* sm:text-lg */
`;

/* Cards */
export const Card = styled.div`
  padding: 22px;
  background: #ffffff;
  border: 1px solid #007c10;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  margin-bottom: 32px;

  @media print {
    margin-bottom: 0;
  }
`;

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;

export const DetailsList = styled.div`
  & > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e8eef1;
    gap: 1rem;
  }
  & > div:last-child {
    border-bottom: 0;
  }
  & > div:first-child {
    border-top: 1px solid #e8eef1;
  }
`;

export const Label = styled.span`
  color: #231f20;
  font-weight: 500;
  font-size: 16px;
`;
export const ValueStrong = styled.span`
  color: #231f20;
  font-weight: 500;
  font-size: 16px;
`;
export const Value = styled.span`
  color: #231f20;
  font-size: 16px;
  font-weight: 500;
  text-align: right;
`;
export const Mono = styled.span`
  font-size: 16px;
  color: #231f20;
  font-weight: 500;
  word-break: break-all;
  text-align: right;
`;

/* Info alert (blue variant) */
export const InfoAlert = styled.div`
  background: #f7f9ff; /* blue-50 */
  border: 2px solid #0186c9; /* blue-300 */
  border-radius: 1rem;
  padding: 1rem;
  margin-bottom: 2rem;
`;
export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 16px;
  @media print {
    margin-bottom: 0px;
  }
`;
export const InfoTitle = styled.h2`
  margin: 0;
  color: #231f20;
  font-weight: 700;
  font-size: 18px;
`;
export const InfoText = styled.p`
  margin: 0;
  color: #231f20;
  font-size: 16px;
`;

/* Buttons */
export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const PrimaryButton = styled.button`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #fff;
  background: #005d1f;
  padding: 0.75rem 1rem;
  border-radius: 9999px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 12px 20px -5px rgba(0, 0, 0, 0.15),
      0 6px 8px -3px rgba(0, 0, 0, 0.06);
  }
`;

export const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #000000;
  padding: 0.75rem 2rem;
  cursor: pointer;
  width: 100%;
  max-width: 264px;
  min-width: 200px;
  height: 44px;
  font-weight: 500;
  font-size: 16px;
  transition: background 0.2s ease;

  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 80px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0 auto;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    background: #005d1f;
    color: #ffffff;
    svg,
    path {
      fill: #ffffff;
    }
  }

  &:disabled {
    background: #d1d5db; /* gray-300 */
    color: #6b7280; /* gray-500 */
    border: 1px solid #d1d5db; /* gray-300 */
    cursor: not-allowed;
  }
`;

export const BottomActions = styled.div`
  text-align: center;
`;

export const PrintableDiv = styled.div`
  font-family: 'Graphik', Helvetica Neue, Helvetica, Arial, sans-serif;

  @media print {
    padding: 30px;
    background: #ffffff;
    height: 100%;
    width: 100%;
    font-family: 'Graphik', Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
`;
